import axios from 'axios';

const ApiInstance = axios.create({
  crossDomain: false,
  crossOrigin: false,
  timeout: 180000,
  withCredentials: false
});

export default ApiInstance;
